<!-- 设置集成系统页面，仅做嵌套使用 -->
<template>
  <div class="mainContent bg-contain common-blue-contain">
    <iframe id="iframe" v-if="showSystemPath" :src="showSystemPath" width="100%" height="100%" frameborder="0" allow="encrypted-media; microphone; fullscreen; autoplay; speaker; midi;"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },

  computed: {
    showSystemPath() {
      return this.$store.state.systemPath
    },
  },
  watch: {
    showSystemPath(val) {
      if (val) {
      }
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped></style>
